import { API_BASE_URL, apiGet } from '@/api/http';

import type { PartnerProgram } from '@/types/recruiter';

export const getPartnerPrograms = (query: string = '') =>
  apiGet<PartnerProgram[]>(`${API_BASE_URL}partner-programs/${query}`);
